module.exports = __webpack_public_path__ + "static/img/zhengshu6.8a3049b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengshu6.png
// module id = vLYS
// module chunks = 1